<div class="container responsive-height-90" fxLayout="column ">
  <div class="row d-flex px-2 py-4">
    <div class="col-7">
      <button type="button" class="back-btn" mat-mini-fab [routerLink]="'/miniapps'"
        style="vertical-align: bottom;">
        <mat-icon>
          chevron_left
        </mat-icon>
      </button>
      <label class="px-2" style="font-style: normal;
            font-weight: 600;
            font-size: 18px;
            line-height: 22px;
            letter-spacing: 0.002em;
            color: #0E0E0E;">New Mini App
      </label>
    </div>
    <div class="col-5 no-padding text-end">
      <div class="hidden-gt-md">
        <button (click)="oncheckPreview()" style="font-style: normal;
          font-weight: 500;
          font-size: 12px;
          line-height: 18px;
          border: none;
          background: none;
          color: #386AF6;">Check Preview</button>
      </div>
    </div>
  </div>
  <div fxLayout="row" class="px-2">
    <mat-card class="responsive-max-width" style="border-radius: 12px;" fxLayout="column " fxFlex="70">
      <mat-stepper labelPosition="bottom" linear #horizantalstepper style="width: 100%;">
        <!-- linear -->
        <mat-step-header role="tab" aria-selected="true"></mat-step-header>
        <ng-template matStepperIcon="edit">
          <mat-icon style="color:#00BA34;font-size: 26px; margin-left: -5px; margin-top: -5px;">
            check_circle
          </mat-icon>
        </ng-template>
        <!-- <ng-template matStepperIcon="active">
         
      </ng-template> -->
        <mat-step [stepControl]="verifyDetailsFormGroup && (phoneNumberVerification || emailVerification)" [completed]="completed1">
          <form [formGroup]="verifyDetailsFormGroup">
            <ng-template matStepLabel><label class="responsive-custom-font-styles">Verify Details</label></ng-template>
            <div fxLayout="column" fxLayoutGap="30px" style="margin: 3% 0% 0% 4%;">
              <div fxLayout="row" fxLayoutAlign="start center">
                <span class="step-number">Step 1 </span>
                <mat-icon style="color: #386AF6;font-size: 1.3em;text-align: center;">
                  chevron_right
                </mat-icon> <label class="step-label">Verify Details</label>
              </div>
              <div fxLayout="column">
                <div fxLayout="row" fxLayoutGap="5px">
                  <mat-label class="mat-input-custom-label responsive-custom-font-miniapps-config">Display
                    name*</mat-label>
                  <mat-icon (click)="openGuidelinespopup()"
                    tooltip='This should reflect your business name.It should be atleast 3 characters'
                    placement="top left"
                    style="color: #D6D6D6;cursor: pointer;font-size: 18px;height:1vh;vertical-align: text-top;">
                    <img src="assets/info-icon.svg" style="width: 55%;vertical-align: top !important;">
                  </mat-icon>
                </div>
                <mat-form-field class="input-full-width" floatLabel='never'>
                  <input type="text" class="placeholder-input" matInput formControlName="displayName"
                    placeholder="Enter display name">
                  <mat-error
                    *ngIf="verifyDetailsFormGroup.controls.displayName.invalid && verifyDetailsFormGroup.controls.displayName.errors.required">
                    Display Name is required

                  </mat-error>
                  <!-- <mat-form-field class="input-full-width" floatLabel='never'> -->
                  <!-- <label class="input-label responsive-custom-font-miniapps-config" style="margin-top: 30px;">Choose the type of MiniApps*</label>
                    <mat-select [(value)]="selected" required formControlName="miniappsType">
                      <mat-option class="placeholder-input" value="" disabled selected>Select miniapps</mat-option>
                      <mat-option value="Education">Education</mat-option>
                      <mat-option value="News">News</mat-option>
                      <mat-option value="Games">Games</mat-option>
                      <mat-option value="Others">Others</mat-option>
                    </mat-select> -->
                  <!-- </mat-form-field> -->
                </mat-form-field>
              </div>
              <!-- <div fxLayout="column">
                <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start end">
                  <label class="mat-input-custom-label">Display name*</label>
                  <mat-icon tooltip="This should reflect your business name.It should be atleast 3 characters"
                    placement="top left"
                    style="color: #D6D6D6;cursor: pointer;font-size: 18px;height:1vh;width: 75%;vertical-align: baseline !important;"
                    (click)="openGuidelinespopup()">info
                  </mat-icon>
                </div>
                <mat-form-field class="input-full-width" floatLabel='never'>
                  <input type="text" class="placeholder-input" matInput formControlName="displayName"
                    placeholder="Enter display name">
                  <mat-error
                    *ngIf="verifyDetailsFormGroup.controls.displayName.invalid && verifyDetailsFormGroup.controls.displayName.errors.required">
                    Display Name is required

                  </mat-error>
                </mat-form-field>
              </div> -->
              <div fxLayout="column">
                <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                  <label class="mat-input-custom-label responsive-custom-font-bot-config">Choose the type of mini
                    app*</label>
                </div>
                <mat-form-field class="input-full-width" floatLabel='never' style="margin-bottom: 0px;">
                  <!-- <label class="input-label responsive-custom-font-miniapps-config" style="margin-top: 30px;">Choose the type of mini app*</label> -->
                  <mat-label>Select mini app</mat-label>
                  <mat-select required formControlName="miniappsType" class="placeholder-input">
                    <!-- <mat-option class="placeholder-input" value="" disabled selected>Select mini app</mat-option> -->
                    <mat-option value="NATIVE">Native</mat-option>
                    <mat-option value="WEB">Web</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxLayout="column">
                <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                  <label class="mat-input-custom-label responsive-custom-font-bot-config">Choose the category of
                    mini app*</label>
                </div>
                <mat-form-field class="input-full-width" floatLabel='never' style="margin-bottom: 0px;">
                  <!-- <label class="input-label responsive-custom-font-miniapps-config" style="margin-top: 30px;">Choose the type of mini app*</label> -->
                  <mat-label>Select category</mat-label>
                  <mat-select required formControlName="miniappsCategory" class="placeholder-input">
                    <!-- <mat-option class="placeholder-input" value="" disabled selected>Select category</mat-option> -->
                    <mat-option value="Education">Education</mat-option>
                    <mat-option value="News">News</mat-option>
                    <mat-option value="Games">Games</mat-option>
                    <mat-option value="Others">Others</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div style="font-family: Montserrat;">
                <label style="font-size: 10px; font-weight: 700; margin-bottom: 10px; line-height: 12.19px; letter-spacing: 0.2px;">Select Verification mode</label>
                <div>
                  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" style="margin-bottom: 18px;">
                    <input type="radio"  name="verificationType" [value]="'phone'" [checked]="verificationType === 'phone'" (change)="selectVerificationType('phone')">
                    <label style="font-size: 10px; font-weight: 700; line-height: 12.19px; letter-spacing: 0.2px;" for="phoneRadio">Phone number</label>
                    <input type="radio"  name="verificationType" [value]="'email'" [checked]="verificationType === 'email'" (change)="selectVerificationType('email')">
                    <label style="font-size: 10px; font-weight: 700; line-height: 12.19px; letter-spacing: 0.2px;" for="emailRadio">Email</label>
                  </div>
                  <div *ngIf="verificationType === 'phone'">
                    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                      <label class="mat-input-custom-label responsive-custom-font-bot-config">Phone number*</label>
                    </div>
                    <mat-form-field class="input-full-width" floatLabel='never'>
                      <input type="text" class="placeholder-input" matInput formControlName="phoneNumber"
                             placeholder="Enter business phone no." (keypress)="keyPress($event)" maxlength="10" minlength="10">
                      <mat-icon style="color:green;" fxLayoutAlign="end end" matSuffix *ngIf="phoneNumberVerified">
                        check_circle
                      </mat-icon>
                      <button type="button" matSuffix *ngIf="!phoneNumberVerified"
                              [disabled]="verifyDetailsFormGroup.invalid" class="verify-btn" (click)="verify()">Verify</button>
                      <mat-error *ngIf="verifyDetailsFormGroup.controls.phoneNumber.invalid && verifyDetailsFormGroup.controls.phoneNumber.errors.required">
                        Phone Number is required
                      </mat-error>
                      <mat-error *ngIf="verifyDetailsFormGroup.controls.phoneNumber.invalid && (verifyDetailsFormGroup.controls.phoneNumber.errors.duplicate && duplicateMobileNumber)">
                        {{duplicateMobileNumber}}
                      </mat-error>
                      <mat-error *ngIf="verifyDetailsFormGroup.controls.phoneNumber.valid || verifyDetailsFormGroup.controls.phoneNumber.errors.maxlength ||verifyDetailsFormGroup.controls.phoneNumber.errors.minlength">
                        Phone number must be at least 10 numbers
                      </mat-error>
                    </mat-form-field>
                  </div>
              
                  <div *ngIf="verificationType === 'email'">
                    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                      <label class="mat-input-custom-label responsive-custom-font-bot-config">Email*</label>
                    </div>
                    <mat-form-field class="input-full-width" floatLabel='never'>
                      <input type="text" class="placeholder-input" matInput formControlName="email"
                             placeholder="Enter business email">
                      <mat-icon style="color:green;" fxLayoutAlign="end end" matSuffix *ngIf="emailVerified">
                        check_circle
                      </mat-icon>
                      <button type="button"  matSuffix *ngIf="!emailVerified"
                              class="verify-btn" [disabled]="verifyDetailsFormGroup.invalid" (click)="verifyEmail()">Verify</button>
                      <mat-error *ngIf="verifyDetailsFormGroup.controls.email.invalid && verifyDetailsFormGroup.controls.email.errors.required">
                        EmailId is required
                      </mat-error>
                      <mat-error *ngIf="verifyDetailsFormGroup.controls.email.invalid && (verifyDetailsFormGroup.controls.email.errors.duplicate && duplicateEmailId)">
                        {{duplicateEmailId}}
                      </mat-error>
                      <mat-error *ngIf="verifyDetailsFormGroup.controls.email.invalid && verifyDetailsFormGroup.controls.email.errors.pattern" >
                        Enter a valid emailId
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                </div>
              <div fxLayout="row" fxLayoutGap="20px" class="responsive-flex-direction-column-reverse">
                <button type="button" class="verify-btn responsive-width-95" fxFlex="33" fxLayoutAlign="center center"
                  (click)="saveMiniAppsDetails('verifyDetails','saveandexit')" style="padding:10px 0;"
                  [disabled]="!phoneNumberVerified && !emailVerified" [routerLink]="'/miniapps'">Save & Exit
                  <mat-icon>
                    chevron_right
                  </mat-icon>
                </button>
                <button type="button" class="verify-btn responsive-width-95" fxFlex="33" fxLayoutAlign="center center"
                  (click)="saveMiniAppsDetails('verifyDetails')" style="background: #386AF6; color:#fff"
                  [disabled]="!phoneNumberVerified && !emailVerified" matStepperNext>Continue
                  <mat-icon>
                    chevron_right
                  </mat-icon></button>
              </div>
            </div>
          </form>
        </mat-step>

        <mat-step [stepControl]="miniappsDetailsFormGroup" [completed]="completed2">
          <form [formGroup]="miniappsDetailsFormGroup">
            <ng-template matStepLabel><label class="responsive-custom-font-styles">Mini App
                Details</label></ng-template>
            <div fxLayout="column" fxLayoutGap="15px" style="margin: 3% 0% 0% 4%;">
              <div fxLayout="row" fxLayoutAlign="start center">
                <span class="step-number">Step 2 </span>
                <mat-icon style="color: #0d6efd;font-size: 1.3em;text-align:center;">
                  chevron_right
                </mat-icon> <label class="step-label">Mini App Details</label>
              </div>
              <!-- <mat-form-field class="input-full-width" floatLabel='never'>
                <label class="input-label responsive-custom-font-miniapps-config">Choose the type of MiniApps*</label>
                <mat-select [(value)]="selected" required formControlName="miniappsType">
                  <mat-option class="placeholder-input" value="" disabled selected>Select miniapps</mat-option>
                  <mat-option value="Education">Education</mat-option>
                  <mat-option value="Ecommerce">E-commerce</mat-option>
                  <mat-option value="null">Others</mat-option>
                </mat-select>
              </mat-form-field> -->

              <div fxLayout="column">
                <div fxLayout="row" fxLayoutGap="10px">
                  <label class="input-label responsive-custom-font-bot-config ">Mini App Icon*</label>
                </div>
                <label class="bot-profile-icon-header"
                  style="font-family: 'Montserrat';font-style: normal;font-weight: 400;font-size: 14px;">This will
                  be
                  visible
                  as
                  your mini app profile icon</label>
                <div *ngIf="!isImageUploaded">
                  <div>
                    <p class="profile-pic-header">Select a profile picture from the templates and edit it
                      later
                    </p>
                    <div class="form-group" fxLayout="row" fxLayoutGap="2px" style="position: relative">
                      <label class="responsive-margin-right-5">
                        <input type="radio" name="profilePhoto" id="option1" formControlName="profilePhoto" value="1"
                          class="card-input-element" (change)="onclickOfImage($event)" />
                        <div fxLayout="column" class="bot-img card-input" fxLayoutAlign="center center">
                          <div fxLayoutAlign="end end" style="margin:1px;height: 1vh;width: 100%;">
                            <mat-icon style="color:green;font-size: 15px;height: 10px;width: 18px;"
                              *ngIf="miniappsDetailsFormGroup.controls.profilePhoto.value == '1'">check_box
                            </mat-icon>
                          </div>

                          <div fxLayout="column" fxLayoutAlign="center center">
                            <div class="tempalte-img"><svg width="53" height="53" viewBox="0 0 53 53" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="26.051" cy="26.051" r="26.051" fill="#FCF3D3" />
                              </svg>
                            </div>
                            <div class="template-icon-img"><img src="assets/bots1-icon.svg" /></div>
                          </div>

                        </div>
                      </label>
                      <label class="responsive-margin-right-5">
                        <input type="radio" name="profilePhoto" id="option2" formControlName="profilePhoto" value="2"
                          class="card-input-element" (change)="onclickOfImage($event)" />
                        <div fxLayout="column" class="bot-img card-input" fxLayoutAlign="center center">
                          <div fxLayoutAlign="end end" style="margin:1px;height: 1vh;width: 100%;">
                            <mat-icon style="color:green;font-size: 15px;height: 10px;width: 18px;"
                              *ngIf="miniappsDetailsFormGroup.controls.profilePhoto.value == '2'">check_box
                            </mat-icon>
                          </div>

                          <div fxLayout="column" fxLayoutAlign="center center">
                            <div class="tempalte-img"><svg width="53" height="53" viewBox="0 0 53 53" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="26.051" cy="26.051" r="26.051" fill="#C5F3F1" />
                              </svg>
                            </div>
                            <div class="template-icon-img"><img src="assets/bots1-icon.svg" /></div>
                          </div>


                        </div>
                      </label>
                      <label class="responsive-margin-right-5">
                        <input type="radio" name="profilePhoto" id="option3" formControlName="profilePhoto" value="3"
                          class="card-input-element" (change)="onclickOfImage($event)" />
                        <div fxLayout="column" class="bot-img card-input" fxLayoutAlign="center center">
                          <div fxLayoutAlign="end end" style="margin:1px;height: 1vh;width: 100%;">
                            <mat-icon style="color:green;font-size: 15px;height: 10px;width: 18px;"
                              *ngIf="miniappsDetailsFormGroup.controls.profilePhoto.value == '3'">check_box
                            </mat-icon>
                          </div>

                          <div fxLayout="column" fxLayoutAlign="center center">
                            <div class="tempalte-img"><svg width="53" height="53" viewBox="0 0 53 53" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="26.051" cy="26.051" r="26.051" fill="#FFE5D5" />
                              </svg>
                            </div>
                            <div class="template-icon-img"><img src="assets/bots1-icon.svg" /></div>
                          </div>

                        </div>
                      </label>
                      <label>
                        <input type="radio" name="profilePhoto" id="option4" formControlName="profilePhoto" value="4"
                          class="card-input-element" (change)="onclickOfImage($event)" />
                        <div fxLayout="column" class="bot-img card-input" fxLayoutAlign="center center">
                          <div fxLayoutAlign="end end" style="margin:1px;height: 1vh;width: 100%;">
                            <mat-icon style="color:green;font-size: 15px;height: 10px;width: 18px;"
                              *ngIf="miniappsDetailsFormGroup.controls.profilePhoto.value == '4'">check_box
                            </mat-icon>
                          </div>

                          <div fxLayout="column" fxLayoutAlign="center center">
                            <div class="tempalte-img"><svg width="53" height="53" viewBox="0 0 53 53" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="26.051" cy="26.051" r="26.051" fill="#E1E9FE" />
                              </svg>
                            </div>
                            <div class="template-icon-img"><img src="assets/bots1-icon.svg" /></div>
                          </div>

                        </div>
                      </label>
                    </div>
                  </div>
                  <div class=" hidden-sm Or">Or</div>
                  
                  <div class="hidden-gt-md" style="display:flex;flex-direction: row;align-items: center;">
                    <div style="border: 1px solid #F2F2F2;width: 40%;height: 1%;"></div>
                    <div class="py-2 px-4 Or">Or</div>
                    <div style="border: 1px solid #F2F2F2;width: 40%;height: 1%;"></div>
                  </div>
                  <div class="border-box text-center pt-4 col-5">
                    <input #fileInput type="file" hidden (change)="fileUpload($event)" accept="image/*">
                    <button type="button" class="upload-btn" (click)="fileInput.click()">Upload an Image
                      <mat-icon style="vertical-align: middle;">
                        chevron_right
                      </mat-icon></button>
                    <div class="pt-3 px-3">
                      <p class="image-upload">Select image for profile photo as JPG or PNG smaller than 10 MB</p>
                    </div>
                    <div fxlayout="row" *ngIf="file?.name" class="px-3 pb-3">
                      <label>{{file?.name}}</label>
                    </div>
                  </div>
                </div>
                <div *ngIf="isImageUploaded">
                  <div fxLayout="row" fxLayoutAlign="start center">
                    <div class="selected-bot-img" fxLayoutAlign="center center">
                      <img class="hidden-sm" [src]="uploadedImageSrc" height="65" width="65" />
                      <img class="hidden-gt-md" [src]="uploadedImageSrc" width="52" height="52" />
                    </div>
                    <div fxLayout="column">
                      <button type="button" mat-button class="profilechange-btn" fxLayoutAlign="center center"
                        style="padding:5px 25px;font-size: 10px;" (click)="changeProfilePhoto()">
                        <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"
                          class="hidden-gt-md">
                          <path
                            d="M15.8903 5.44038C15.6162 5.16523 15.1799 5.16443 14.9209 5.43859L14.2412 6.11597L14.2414 6.00283C14.2474 2.78778 11.6349 0.181823 8.43603 0.175908C6.90123 0.17307 5.44606 0.768124 4.34545 1.84852C4.0703 2.12265 4.0695 2.5589 4.34366 2.81794C4.61779 3.09308 5.05404 3.09389 5.31308 2.81973C6.15474 1.99735 7.25413 1.54705 8.43354 1.54923C10.8731 1.55374 12.8728 3.5446 12.8682 6.00034L12.868 6.11349L12.1907 5.43368C11.9166 5.15854 11.4803 5.15773 11.2213 5.43189C10.9623 5.70605 10.9454 6.14228 11.2195 6.40131L13.0579 8.26251C13.1869 8.39201 13.3645 8.47314 13.5422 8.47347C13.7199 8.4738 13.8977 8.40955 14.0273 8.2643L15.8886 6.40986C16.1637 6.13573 16.1646 5.69947 15.8904 5.44044L15.8903 5.44038Z"
                            fill="#386AF6" stroke="#386AF6" stroke-width="0.3" />
                          <path
                            d="M11.537 9.14594C10.6953 9.96832 9.59594 10.4186 8.41653 10.4164C5.977 10.4119 3.9773 8.42107 3.98184 5.96532L3.98205 5.85218L4.65934 6.53199C4.78837 6.66149 4.96595 6.74262 5.14367 6.74294C5.32139 6.74327 5.49922 6.67903 5.62876 6.53378C5.90391 6.25965 5.90471 5.82339 5.63056 5.56436L3.79218 3.7194C3.51805 3.44425 3.08179 3.44345 2.82276 3.71761L0.961439 5.57205C0.686294 5.84618 0.685487 6.28244 0.959647 6.54147C1.23381 6.8005 1.67003 6.81743 1.92907 6.54327L2.60887 5.86597L2.60855 5.979C2.60261 9.19405 5.21504 11.8 8.41396 11.8059C9.94875 11.8088 11.4039 11.2137 12.5045 10.1333C12.7797 9.85918 12.7805 9.42293 12.5063 9.16389C12.2483 8.88866 11.8122 8.88786 11.5369 9.14587L11.537 9.14594Z"
                            fill="#386AF6" stroke="#386AF6" stroke-width="0.3" />
                        </svg>&nbsp;
                        Change Profile Photo
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div fxLayout="column" fxlayoutGap="1px">
                <mat-label class="input-label responsive-custom-font-bot-config ">Description*</mat-label>

                <mat-form-field class="input-full-width" floatLabel='never' style="margin-top:-3.5%;">

                  <textarea matInput class="placeholder-input" #message maxlength="500" minlength="2"
                    cdkTextareaAutosize cdkAutosizeMaxRows="4" placeholder="Type here" formControlName="description"
                    style="overflow-y: auto;scroll-behavior: smooth;"></textarea>
                  <span matSuffix>{{message.value.length}} / 500</span>
                  <mat-error *ngIf="
                              !miniappsDetailsFormGroup.controls['description'].valid &&
                              miniappsDetailsFormGroup.controls['description'].touched
                            ">
                    {{ getErrorDescription() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxLayout="column" fxlayoutGap="1px">
                <mat-card style="box-shadow: none;">
                  <mat-label class="input-label responsive-custom-font-bot-config">Add labels/tags to this mini app
                    for easy discoverability</mat-label>
                  <div class="editor-tag input-full-width py-1" (click)="focusTagInput()">
                    <span class="tag-item py-1 mr-2" *ngFor="let tag of tags">
                      <span class="pl-2">{{tag}}</span>
                      <span class="remove-tag pl-2" (click)="removeTag(tag)">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="10" cy="10" r="10" fill="white" />
                          <path
                            d="M10.9391 9.99943L13.803 7.14179C13.9284 7.01635 13.9989 6.84623 13.9989 6.66884C13.9989 6.49146 13.9284 6.32133 13.803 6.1959C13.6776 6.07047 13.5075 6 13.3301 6C13.1528 6 12.9827 6.07047 12.8572 6.1959L10 9.06021L7.14276 6.1959C7.01735 6.07047 6.84725 6 6.66988 6C6.49252 6 6.32242 6.07047 6.19701 6.1959C6.07159 6.32133 6.00114 6.49146 6.00114 6.66884C6.00114 6.84623 6.07159 7.01635 6.19701 7.14179L9.06091 9.99943L6.19701 12.8571C6.13458 12.919 6.08504 12.9927 6.05122 13.0738C6.01741 13.155 6 13.2421 6 13.33C6 13.418 6.01741 13.505 6.05122 13.5862C6.08504 13.6674 6.13458 13.741 6.19701 13.803C6.25892 13.8654 6.33259 13.915 6.41375 13.9488C6.49491 13.9826 6.58196 14 6.66988 14C6.75781 14 6.84486 13.9826 6.92602 13.9488C7.00718 13.915 7.08085 13.8654 7.14276 13.803L10 10.9387L12.8572 13.803C12.9192 13.8654 12.9928 13.915 13.074 13.9488C13.1551 13.9826 13.2422 14 13.3301 14C13.418 14 13.5051 13.9826 13.5863 13.9488C13.6674 13.915 13.7411 13.8654 13.803 13.803C13.8654 13.741 13.915 13.6674 13.9488 13.5862C13.9826 13.505 14 13.418 14 13.33C14 13.2421 13.9826 13.155 13.9488 13.0738C13.915 12.9927 13.8654 12.919 13.803 12.8571L10.9391 9.99943Z"
                            fill="#386AF6" stroke="#386AF6" stroke-width="0.5" />
                        </svg>
                      </span>
                    </span>
                    <input #tagInput type="text" class="input-tag px-0" (keyup)="onKeyUp($event)"
                      [ngStyle]="tags.length == 0 && {'width':'50%'}"
                      [placeholder]="tags.length == 0?'Type here to add labels/tags...':''">
                  </div>
                  <p class="text-danger" *ngIf="tags_error!=''">{{tags_error}}</p>
                </mat-card>
              </div>
              <div fxLayout="column">
                <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                  <label class="mat-input-custom-label responsive-custom-font-bot-config">Choose the language supported by mini app*</label>
                </div>
                <mat-form-field class="input-full-width" floatLabel='never' style="margin-bottom: 0px;">
                  <!-- <label class="input-label responsive-custom-font-miniapps-config" style="margin-top: 30px;">Choose the type of mini app*</label> -->
                  <mat-label>Select language</mat-label>
                  <mat-select required formControlName="languages" multiple class="placeholder-input">
                    <!-- <mat-option class="placeholder-input" value="" disabled selected>Select language</mat-option> -->
                    <mat-option value="EN">English</mat-option>
                    <mat-option value="HI">Hindi</mat-option>
                    <mat-option value="GU">Gujarati</mat-option>
                    <mat-option value="MR">Marathi</mat-option>

                  </mat-select>
                </mat-form-field>
              </div>
              

              <div fxLayout="row" fxLayoutGap="20px" class="responsive-flex-direction-column-reverse">
                <button type="button" class="verify-btn responsive-width-95" fxFlex="33" fxLayoutAlign="center center"
                  style="padding:10px 0;" [disabled]="miniappsDetailsFormGroup.invalid"
                  (click)="saveMiniAppsDetails('MiniAppsDetails','saveandexit')">Save &
                  Exit <mat-icon>
                    chevron_right
                  </mat-icon></button>
                <button type="button" [disabled]="miniappsDetailsFormGroup.invalid"
                  class="verify-btn responsive-width-95" fxFlex="33" fxLayoutAlign="center center"
                  style="padding:10px 0;background: #386AF6; color:#fff" matStepperNext
                  (click)="saveMiniAppsDetails('MiniAppsDetails')">Continue <mat-icon>
                    chevron_right
                  </mat-icon></button>
              </div>

            </div>
          </form>
        </mat-step>
        <mat-step [stepControl]="additionalInfoFormGroup" [completed]="completed3">
          <form [formGroup]="additionalInfoFormGroup">
            <ng-template matStepLabel><label class="responsive-custom-font-styles">Additional Info</label></ng-template>
            <div fxLayout="column" fxLayoutGap="10px" style="margin: 3% 0% 0% 4%;">
              <div fxLayout="row" fxLayoutAlign="start center" style="padding-bottom: 3%;">
                <span class="step-number">Step 3</span>
                <mat-icon style="color: #0d6efd;font-size: 1.3em;text-align:center;">
                  chevron_right
                </mat-icon> <label class="step-label">Additional Info</label>
              </div>
              <!-- <div fxLayout="column" fxLayoutGap="5px">
                <div fxLayout="row" fxLayoutGap="5px">
                  <label class="input-label">Add Welcome Banner </label>
                  <svg class="hidden-sm"
                    tooltip="Brief overview of miniapps displayed once when user clicks on the miniapps."
                    placement="top left" style="cursor:pointer" width="13" height="14" viewBox="0 0 13 14" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle r="6.5" transform="matrix(1 0 0 -1 6.5 7)" fill="#D6D6D6" />
                    <path
                      d="M7.42606 4.95466C7.98309 4.95466 8.43464 4.50311 8.43464 3.94608C8.43464 3.38906 7.98309 2.9375 7.42606 2.9375C6.86904 2.9375 6.41748 3.38906 6.41748 3.94608C6.41748 4.50311 6.86904 4.95466 7.42606 4.95466Z"
                      fill="white" />
                    <path
                      d="M8.45726 9.04667C8.4294 9.02793 8.39807 9.01494 8.36512 9.00847C8.33217 9.00199 8.29826 9.00217 8.26538 9.00898C8.23249 9.01579 8.2013 9.0291 8.17363 9.04813C8.14597 9.06716 8.12238 9.09152 8.10425 9.11979C7.8605 9.48078 7.5619 9.8015 7.21922 10.0704C7.13602 10.1334 6.82588 10.373 6.69476 10.3225C6.60399 10.2948 6.65694 10.1158 6.67459 10.0401L6.80823 9.64426C6.8637 9.48288 7.82942 6.61851 7.93532 6.29072C8.09165 5.81165 8.02357 5.34013 7.31 5.4536C7.11584 5.47377 5.14659 5.72844 5.11129 5.73096C5.07818 5.73311 5.04581 5.74176 5.01604 5.75642C4.98628 5.77108 4.95969 5.79146 4.93779 5.8164C4.9159 5.84133 4.89914 5.87034 4.88845 5.90175C4.87777 5.93317 4.87338 5.96638 4.87553 5.99949C4.87768 6.03261 4.88634 6.06497 4.901 6.09474C4.91566 6.12451 4.93604 6.15109 4.96097 6.17299C4.98591 6.19488 5.01491 6.21165 5.04633 6.22233C5.07774 6.23301 5.11095 6.2374 5.14407 6.23525C5.14407 6.23525 5.9005 6.13691 5.98371 6.12935C6.02633 6.12519 6.06925 6.13345 6.10728 6.15313C6.14531 6.17282 6.17683 6.20309 6.19804 6.24029C6.24372 6.38153 6.23746 6.53443 6.18038 6.67146C6.11483 6.92361 5.07851 9.84345 5.04573 10.0124C5.01057 10.1538 5.02033 10.3026 5.07366 10.4381C5.12698 10.5737 5.22121 10.6893 5.34326 10.7688C5.57234 10.9215 5.84509 10.995 6.11987 10.9781C6.38704 10.9748 6.65125 10.9218 6.899 10.8218C7.52684 10.5696 8.18242 9.89892 8.52786 9.37194C8.55761 9.3184 8.56684 9.25586 8.55385 9.196C8.54086 9.13614 8.50652 9.08306 8.45726 9.04667Z"
                      fill="white" />
                  </svg>
                </div>


                <div fxLayout="row">
                  <div class="upload-template" *ngIf="!welcomeBannerName">
                    <button type="button" mat-button class="verify-btn template-btn" fxLayoutAlign="center center"
                      (click)="selectTemplate()" *ngIf="!welcomeBannerName">Select Template</button>
                    <p class="profile-pic-header">Select a welcome banner from the templates and edit it later
                    </p>
                  </div>
                  <div *ngIf="!welcomeBannerName" class="upload-templateOR" fxLayoutAlign="center center"> Or </div>
                  <div class="upload-template" *ngIf="!welcomeBannerName">
                    <button type="button" mat-button class="verify-btn template-btn" fxLayoutAlign="center center"
                      *ngIf="!welcomeBannerName" (click)="clickInput()">
                      Upload Image
                    </button>
                    <input type="file" id="imageFileUpload" accept="image/*" (change)="selectTemplateFile($event)"
                      style="display:none">
                    <p class="profile-pic-header">Select image for profile photo as JPG or PNG SMALLER THAN 10 MB
                    </p>
                  </div>
                </div>
                <div fxLayout="row" fxLayoutGap="20px">
                  <div fxLayout="row" fxLayoutAlign="space-between center"
                    class="welcomeBannerNameSection responsive-width-auto" *ngIf="welcomeBannerName">
                    <span style="min-width:100px">{{welcomeBannerName}}</span>
                    <div (click)="onDelete()">
                      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="14" cy="14" r="14" fill="#ECF1FF" />
                        <path
                          d="M8.85714 19.4444C8.85714 20.3 9.62857 21 10.5714 21H17.4286C18.3714 21 19.1429 20.3 19.1429 19.4444V10.1111H8.85714V19.4444ZM10.5714 11.6667H17.4286V19.4444H10.5714V11.6667ZM17 7.77778L16.1429 7H11.8571L11 7.77778H8V9.33333H20V7.77778H17Z"
                          fill="#386AF6" />
                      </svg>

                    </div>
                  </div>


                </div>

              </div> -->
              <div fxLayout="row">
                <mat-form-field class="input-full-width" floatLabel='always'>
                  <!-- <mat-label Style="font-weight: 500;color: #0E0E0E;">Customer Support Phone Number </mat-label>
                  <input type="text" matInput formControlName="customer_support_phone"
                    placeholder="Typecustomer support phone number" (keypress)="keyPress($event)"> -->
                  <div fxLayout="column" fxLayoutGap="10px">
                    <mat-label class="mat-input-custom-label">Customer Support Phone Number</mat-label>
                    <input type="text" class="placeholder-input" matInput formControlName="customer_support_phone"
                      placeholder="Typecustomer support phone number" (keypress)="keyPress($event)" maxlength="20"
                      minlength="10">
                  </div>
                  <!-- <mat-error
                  *ngIf="additionalInfoFormGroup.controls.customer_support_phone.invalid && additionalInfoFormGroup.controls.customer_support_phone.errors.required">
                  Customer Support Phone Number is required
                </mat-error> -->
                  <!-- <mat-error
                    *ngIf="additionalInfoFormGroup.controls.customer_support_phone.invalid && additionalInfoFormGroup.controls.customer_support_phone.errors.pattern">
                    Please Enter Valid Phone Number
                  </mat-error> -->
                  <mat-error
                    *ngIf="additionalInfoFormGroup.controls.customer_support_phone.
                valid ||  additionalInfoFormGroup.controls.customer_support_phone.errors.maxlength || additionalInfoFormGroup.controls.customer_support_phone.errors.minlength">


                  </mat-error>
                </mat-form-field>

              </div>
              <div fxLayout="row">
                <mat-form-field class="input-full-width" floatLabel='always'>
                  <!-- <mat-label Style="font-weight: 500;color: #0E0E0E;">Customer Support Email Id*</mat-label>
                  <input type="text" matInput formControlName="customer_support_email"
                    placeholder="Type customer support email Id"> -->
                  <div fxLayout="column" fxLayoutGap="10px">
                    <mat-label class="mat-input-custom-label">Customer Support Email Id*</mat-label>
                    <input type="text" class="placeholder-input" matInput formControlName="customer_support_email"
                      placeholder="Type customer support email Id">
                  </div>
                  <mat-error *ngIf=" !additionalInfoFormGroup.controls['customer_support_email'].valid &&
                    additionalInfoFormGroup.controls['customer_support_email'].touched
                  ">
                    {{ getErrorCustomerEmail() }}
                  </mat-error>
                </mat-form-field>

              </div>
              <div fxLayout="row">
                <mat-form-field class="input-full-width" floatLabel='always'>
                  <div fxLayout="column" fxLayoutGap="10px">
                    <mat-label class="mat-input-custom-label">Customer Support Url</mat-label>
                    <input type="text" class="placeholder-input" matInput formControlName="customer_support_url"
                      placeholder="Type customer support url">
                  </div>
                  <mat-error *ngIf=" !additionalInfoFormGroup.controls['customer_support_url'].valid &&
                    additionalInfoFormGroup.controls['customer_support_url'].touched
                  ">
                    {{ getErrorForLink() }}
                  </mat-error>
                </mat-form-field>

              </div>
              <div fxLayout="column">
                <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                  <label class="mat-input-custom-label responsive-custom-font-bot-config">Permissions required by the mini app</label>
                </div>
                <mat-form-field class="input-full-width" floatLabel='never' style="margin-bottom: 0px;">
                  <!-- <label class="input-label responsive-custom-font-miniapps-config" style="margin-top: 30px;">Choose the type of mini app*</label> -->
                  <mat-label>Choose permission</mat-label>
                  <mat-select formControlName="permissions" multiple class="placeholder-input">
                    <!-- <mat-option class="placeholder-input" value="" disabled selected>Select language</mat-option> -->
                    <mat-option value="CAMERA">Camera</mat-option>
                    <mat-option value="LOCATION">Location</mat-option>
                    <mat-option value="FILE_PICKER">Files</mat-option>
                    <mat-option value="MICROPHONE">Microphone</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxLayout="column" hidden>
                <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                  <label class="mat-input-custom-label responsive-custom-font-bot-config">Profile information required by the mini app</label>
                </div>
                <mat-form-field class="input-full-width" floatLabel='never' style="margin-bottom: 0px;">
                  <!-- <label class="input-label responsive-custom-font-miniapps-config" style="margin-top: 30px;">Choose the type of mini app*</label> -->
                  <mat-label>Select information</mat-label>
                  <mat-select  formControlName="profileInformation" multiple class="placeholder-input">
                    <!-- <mat-option class="placeholder-input" value="" disabled selected>Select language</mat-option> -->
                    <mat-option value="name">Name</mat-option>
                    <mat-option value="gender">Gender</mat-option>
                    <mat-option value="countryCode">Country</mat-option>
                    <mat-option value="stateCode">State</mat-option>
                    <mat-option value="city">City</mat-option>
                    <mat-option value="mobile">Mobile number</mat-option>
                    <mat-option value="email">Email id</mat-option>
                    <mat-option value="dob">Date of birth</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxLayout="row" fxLayoutGap="20px" class="responsive-flex-direction-column-reverse">
                <button type="button" class="verify-btn responsive-width-95"
                  [disabled]="additionalInfoFormGroup.invalid" fxFlex="33" fxLayoutAlign="center center"
                  style="padding:10px 0;" (click)="saveMiniAppsDetails('additionalInfo','saveandexit')">Save & Exit
                  <mat-icon>
                    chevron_right
                  </mat-icon></button>
                <button type="button" [disabled]="additionalInfoFormGroup.invalid"
                  class="verify-btn responsive-width-95" fxFlex="33" fxLayoutAlign="center center"
                  style="padding:10px 0;background: #386AF6; color:#fff" matStepperNext
                  (click)="saveMiniAppsDetails('additionalInfo')">Continue <mat-icon>
                    chevron_right
                  </mat-icon></button>
              </div>
            </div>
          </form>
        </mat-step>
        <mat-step [stepControl]="configueMiniAppsFormGroup">
          <form [formGroup]="configueMiniAppsFormGroup">
            <ng-template matStepLabel><label class="responsive-custom-font-styles">Configure
                Mini App</label></ng-template>
            <div fxLayout="column" fxLayoutGap="10px" style="margin: 3% 0% 0% 4%;">
              <div fxLayout="row" fxLayoutAlign="start center" style="padding-bottom: 3%;">
                <span class="step-number">Step 4</span>
                <mat-icon style="color: #0d6efd;font-size: 1.3em;text-align:center;">
                  chevron_right
                </mat-icon> <label class="step-label">Configure Mini App</label>
              </div>
              <!-- <div fxLayout="row" class="responsive-flex-direction-column">
                <mat-label class="responsive-max-width responsive-custom-font-miniapps-config" fxFlex="22"
                  Style="font-weight: 500;font-size: 12px;color: #0E0E0E;">Add Configuration
                  Parameters
                </mat-label>
                <div class="hidden-gt-md"
                  style="display: flex;border: 1px solid rgb(0 0 0 / 25%);border-radius: 20px;width: 50%;padding: 3%;margin-top: 3%;">
                  <svg style="margin-right: 10%;margin-left: 7%;" width="18" height="15" viewBox="0 0 18 15" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14.144 2.5254L13.6752 2.52453C13.5615 2.52463 13.4498 2.49279 13.353 2.4327C13.2563 2.37261 13.1783 2.2867 13.1278 2.18457L12.5813 1.0869L12.5813 1.08675C12.4302 0.780219 12.196 0.522367 11.9056 0.342063C11.6152 0.16179 11.2801 0.0665884 10.9384 0.0670233L6.32239 0.0584879C5.98072 0.0567917 5.64523 0.150751 5.35419 0.329949C5.06312 0.509146 4.82802 0.766131 4.67568 1.07213L4.12516 2.16778L4.12516 2.16793C4.07434 2.26987 3.99602 2.35548 3.89905 2.41522C3.80207 2.47495 3.69025 2.50637 3.57651 2.50586L3.10802 2.50499C2.29526 2.5044 1.51537 2.82624 0.939665 3.39997C0.363802 3.97356 0.0391086 4.75224 0.0366715 5.56501L0.0253346 11.6961C0.0247442 12.5088 0.346733 13.2886 0.920316 13.8643C1.49405 14.44 2.27259 14.7647 3.08535 14.7671L14.1212 14.7875C14.9339 14.7881 15.7136 14.4663 16.2893 13.8925C16.8652 13.3189 17.1898 12.5404 17.1923 11.7278L17.2036 5.59675C17.2042 4.78398 16.8824 4.00422 16.3088 3.42839C15.7352 2.85268 14.9567 2.52784 14.1439 2.5254L14.144 2.5254ZM15.9662 11.7254C15.9646 12.2129 15.7699 12.6801 15.4244 13.0242C15.0791 13.3684 14.6111 13.5615 14.1236 13.5611L3.0877 13.5407C2.60006 13.5394 2.13282 13.3445 1.7886 12.9991C1.44452 12.6536 1.25135 12.1858 1.25167 11.6981L1.26301 5.56708C1.26436 5.07944 1.45926 4.6122 1.80475 4.26798C2.15024 3.92376 2.6182 3.73057 3.10584 3.73105L3.57433 3.73191C3.91601 3.73361 4.25149 3.63965 4.54253 3.46045C4.8336 3.28126 5.0687 3.02427 5.22105 2.71827L5.77187 1.62247C5.8227 1.52053 5.90101 1.43492 5.99799 1.37518C6.09496 1.31545 6.20663 1.28403 6.32052 1.28454L10.9361 1.29307C11.0499 1.29313 11.1614 1.32497 11.2582 1.38506C11.3549 1.44515 11.4328 1.53106 11.4832 1.63303L12.0297 2.73071L12.0297 2.73086C12.181 3.03739 12.415 3.29524 12.7054 3.47554C12.9959 3.65582 13.331 3.75102 13.6728 3.75058L14.1414 3.75145C14.6291 3.75296 15.0963 3.94785 15.4404 4.29319C15.7847 4.6387 15.9777 5.10664 15.9774 5.59428L15.9662 11.7254Z"
                      fill="#BDBDBD" />
                    <path
                      d="M8.6259 4.35446C7.6503 4.35265 6.71393 4.73852 6.02278 5.427C5.3316 6.11563 4.94227 7.05069 4.94046 8.02629C4.93866 9.00188 5.32453 9.93826 6.01316 10.6294C6.70179 11.3206 7.6367 11.7099 8.61229 11.7117C9.58789 11.7135 10.5243 11.3277 11.2154 10.639C11.9066 9.95039 12.2959 9.01549 12.2977 8.03989C12.2985 7.06457 11.9123 6.1287 11.224 5.43783C10.5355 4.74695 9.60122 4.35731 8.6259 4.35446ZM8.61456 10.4855C7.9642 10.4843 7.34079 10.2248 6.88179 9.76398C6.42268 9.30316 6.16547 8.67891 6.16667 8.02855C6.16788 7.37804 6.42738 6.75479 6.88821 6.29563C7.34887 5.83667 7.97327 5.57947 8.62363 5.58067C9.27399 5.58187 9.8974 5.84137 10.3564 6.30205C10.8155 6.76286 11.0727 7.38711 11.0715 8.03762C11.0696 8.68783 10.8097 9.31065 10.3492 9.76946C9.88855 10.2284 9.26476 10.4859 8.61456 10.4855Z"
                      fill="#BDBDBD" />
                  </svg>

                  <span
                    style="margin-right: 10%;font-style: normal;font-weight: 500;font-size: 14px;line-height: 17px;letter-spacing: 0.2px;color: #0E0E0E;">Camera</span>
                  <label class="switch" fxLayoutAlign="center center">
                    <input type="checkbox" formControlName="allow_user_media">
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="hidden-sm" fxFlex="5">
                  <label class="switch" fxLayoutAlign="center center">
                    <input type="checkbox" formControlName="allow_user_media">
                    <span class="slider round"></span>
                  </label>
                </div>
                <div fxLayoutAlign="center center" class="hidden-sm">
                  <svg
                    tooltip="It provides options to the user for sending messages in rich formats such as images, videos, audio, and documents."
                    placement="top left" style="cursor:pointer" width="13" height="14" viewBox="0 0 13 14" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle r="6.5" transform="matrix(1 0 0 -1 6.5 7)" fill="#D6D6D6" />
                    <path
                      d="M7.42606 4.95466C7.98309 4.95466 8.43464 4.50311 8.43464 3.94608C8.43464 3.38906 7.98309 2.9375 7.42606 2.9375C6.86904 2.9375 6.41748 3.38906 6.41748 3.94608C6.41748 4.50311 6.86904 4.95466 7.42606 4.95466Z"
                      fill="white" />
                    <path
                      d="M8.45726 9.04667C8.4294 9.02793 8.39807 9.01494 8.36512 9.00847C8.33217 9.00199 8.29826 9.00217 8.26538 9.00898C8.23249 9.01579 8.2013 9.0291 8.17363 9.04813C8.14597 9.06716 8.12238 9.09152 8.10425 9.11979C7.8605 9.48078 7.5619 9.8015 7.21922 10.0704C7.13602 10.1334 6.82588 10.373 6.69476 10.3225C6.60399 10.2948 6.65694 10.1158 6.67459 10.0401L6.80823 9.64426C6.8637 9.48288 7.82942 6.61851 7.93532 6.29072C8.09165 5.81165 8.02357 5.34013 7.31 5.4536C7.11584 5.47377 5.14659 5.72844 5.11129 5.73096C5.07818 5.73311 5.04581 5.74176 5.01604 5.75642C4.98628 5.77108 4.95969 5.79146 4.93779 5.8164C4.9159 5.84133 4.89914 5.87034 4.88845 5.90175C4.87777 5.93317 4.87338 5.96638 4.87553 5.99949C4.87768 6.03261 4.88634 6.06497 4.901 6.09474C4.91566 6.12451 4.93604 6.15109 4.96097 6.17299C4.98591 6.19488 5.01491 6.21165 5.04633 6.22233C5.07774 6.23301 5.11095 6.2374 5.14407 6.23525C5.14407 6.23525 5.9005 6.13691 5.98371 6.12935C6.02633 6.12519 6.06925 6.13345 6.10728 6.15313C6.14531 6.17282 6.17683 6.20309 6.19804 6.24029C6.24372 6.38153 6.23746 6.53443 6.18038 6.67146C6.11483 6.92361 5.07851 9.84345 5.04573 10.0124C5.01057 10.1538 5.02033 10.3026 5.07366 10.4381C5.12698 10.5737 5.22121 10.6893 5.34326 10.7688C5.57234 10.9215 5.84509 10.995 6.11987 10.9781C6.38704 10.9748 6.65125 10.9218 6.899 10.8218C7.52684 10.5696 8.18242 9.89892 8.52786 9.37194C8.55761 9.3184 8.56684 9.25586 8.55385 9.196C8.54086 9.13614 8.50652 9.08306 8.45726 9.04667Z"
                      fill="white" />
                  </svg>
                </div>
              </div>
              <div fxLayout="row" class="hidden-sm">
                <label class="camera-label" fxFlex="8">Camera </label>
                <div class="divider"></div>
                <label class="camera-label" fxFlex="8">Gallery</label>
                <div class="divider"></div>
                <label class="camera-label" fxFlex="11">Document</label>
                <div class="divider"></div>
                <label class="camera-label" fxFlex="8">Audio</label>

              </div> -->
              <!-- <div fxLayoutGap="10" class="camera-btn"
                    fxLayoutAlign="center center">
                    <mat-icon style="font-size:21px" fxLayoutAlign="center center"><span class="material-symbols-outlined">
                            photo_camera
                        </span></mat-icon>
                    <span class="camera-label">Camera</span>
                    <div class="py-2" >
                        <label class="switch" fxLayoutAlign="center center">
                            <input type="checkbox" formControlName="allow_user_media">
                            <span class="slider round"></span>
                        </label>
                    </div>
                     <mat-slide-toggle color="primary" formControlName="allow_user_media"></mat-slide-toggle> 
                </div> -->


              <div fxLayout="row">
                <mat-form-field class="input-full-width" floatLabel='always'>
                  <!-- <mat-label Style="font-weight: 500;color: #0E0E0E;">Webhook URL </mat-label>
                  <input type="text" class="placeholder-input" matInput formControlName="webhook_url" placeholder="Type Webhook URL"> -->
                  <div fxLayout="column" fxLayoutGap="18px">
                    <div fxLayout="row" fxLayoutGap="5px">
                      <mat-label class="mat-input-custom-label responsive-custom-font-bot-config">Launch URL
                      </mat-label>
                      <mat-icon class="hidden-sm"
                        tooltip='It will use the interface of this launch url to function on this platform'
                        placement="top left"
                        style="color: #D6D6D6;cursor: pointer;font-size: 18px;height:1vh;vertical-align: text-top;">
                        <img src="assets/info-icon.svg" style="width: 55%;vertical-align: top !important;">
                      </mat-icon>
                    </div>
                    <input type="text" class="placeholder-input" matInput formControlName="webhook_url"
                      placeholder="Type launch URL">
                  </div>
                  <!-- <mat-error
                    *ngIf="configueMiniAppsFormGroup.controls.webhook_url.invalid && configueMiniAppsFormGroup.controls.webhook_url.errors.required">
                    Webhook URL is required
                  </mat-error> -->
                  <mat-error
                    *ngIf="configueMiniAppsFormGroup.controls.webhook_url.invalid && configueMiniAppsFormGroup.controls.webhook_url.errors.pattern">
                    Please enter a valid url
                  </mat-error>
                </mat-form-field>

              </div>
              <div fxLayout="column" hidden>
                <mat-form-field class="input-full-width" floatLabel='always'>
                  <div fxLayout="column" fxLayoutGap="10px">
                    <div fxLayout="row" fxLayoutGap="5px">
                      <mat-label class="mat-input-custom-label responsive-custom-font-bot-config">Persistent Menu
                      </mat-label>
                      <mat-icon class="hidden-sm"
                        tooltip='It allows users to have an always-on interface element inside the miniapps and also helps to reset or restart any flow from specified points'
                        placement="top left"
                        style="color: #D6D6D6;cursor: pointer;font-size: 18px;height:1vh;vertical-align: text-top;">
                        <img src="assets/info-icon.svg" style="width: 55%;vertical-align: top !important;">
                      </mat-icon>
                    </div>
                    <mat-select formControlName="persistentMenu" placeholder="No Button"
                      (selectionChange)="onPersistentMenuSelection($event.value)">
                      <mat-option value="null" class="placeholder-input">None</mat-option>
                      <mat-option class="placeholder-input" style="border:1px solid #ECECEC" value="1">
                        Add 1 Button
                      </mat-option>
                      <mat-option class="placeholder-input" style="border:1px solid #ECECEC" value="2">
                        Add 2 Button
                      </mat-option>
                      <mat-option class="placeholder-input" style="border:1px solid #ECECEC" value="3">
                        Add 3 Button
                      </mat-option>
                      <mat-option class="placeholder-input" style="border:1px solid #ECECEC" value="4">
                        Add 4 Button
                      </mat-option>
                    </mat-select>
                  </div>

                </mat-form-field>
                <!-- <mat-label Style="font-weight: 500;font-size: 12px;color: #0E0E0E;">Persistent Menu</mat-label>
                <button type="button"  mat-button class="verify-btn" style="width:200px;padding:5px 0;" fxLayoutAlign="center center"
                (click)="onPersistentMenuSelection()" >Add Button</button> -->
              </div>
              <div formArrayName="buttons" hidden>
                <div class="responsive-width-auto" fxLayout="column" style="width:500px;padding-bottom: 1rem;  "
                  *ngFor="let element of configueMiniAppsFormGroup.get('buttons')['controls'];let i=index;">
                  <div [formGroupName]="i">
                    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px"
                      style="background:#F4F6FA;border-radius: 8px; padding: 10px;margin-bottom:2%">
                      <label class="dynamic-btn-heading">Button - {{i+1}}</label>
                      <!-- <mat-icon (click)="deleteButton(i)" style="cursor:pointer">delete</mat-icon> -->
                    </div>
                    <div class="responsive-flex-direction-column" fxLayout="row" fxLayoutGap="5%"
                      style="margin-left: 4%">
                      <div fxLayout="column" fxFlex="50" class="responsive-max-width-75">
                        <label class="mat-input-custom-label responsive-button-text"
                          style="margin-bottom:-8px ;">Button
                          Text</label>
                        <mat-form-field floatLabel='never'>
                          <input type="text" class="placeholder-input" matInput placeholder="Enter Button Text"
                            formControlName="body">
                        </mat-form-field>
                      </div>
                      <div fxLayout="column" fxFlex="50" class="responsive-max-width-75">
                        <span class="mat-input-custom-label responsive-button-text"
                          style="margin-bottom:-8px ;"><label>Reply </label>
                          <svg tooltip="Ready response when user clicks on button " class="hidden-sm"
                            placement="top left" style="cursor:pointer; margin-left: 5px;" width="13" height="14"
                            viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle r="6.5" transform="matrix(1 0 0 -1 6.5 7)" fill="#D6D6D6" />
                            <path
                              d="M7.42606 4.95466C7.98309 4.95466 8.43464 4.50311 8.43464 3.94608C8.43464 3.38906 7.98309 2.9375 7.42606 2.9375C6.86904 2.9375 6.41748 3.38906 6.41748 3.94608C6.41748 4.50311 6.86904 4.95466 7.42606 4.95466Z"
                              fill="white" />
                            <path
                              d="M8.45726 9.04667C8.4294 9.02793 8.39807 9.01494 8.36512 9.00847C8.33217 9.00199 8.29826 9.00217 8.26538 9.00898C8.23249 9.01579 8.2013 9.0291 8.17363 9.04813C8.14597 9.06716 8.12238 9.09152 8.10425 9.11979C7.8605 9.48078 7.5619 9.8015 7.21922 10.0704C7.13602 10.1334 6.82588 10.373 6.69476 10.3225C6.60399 10.2948 6.65694 10.1158 6.67459 10.0401L6.80823 9.64426C6.8637 9.48288 7.82942 6.61851 7.93532 6.29072C8.09165 5.81165 8.02357 5.34013 7.31 5.4536C7.11584 5.47377 5.14659 5.72844 5.11129 5.73096C5.07818 5.73311 5.04581 5.74176 5.01604 5.75642C4.98628 5.77108 4.95969 5.79146 4.93779 5.8164C4.9159 5.84133 4.89914 5.87034 4.88845 5.90175C4.87777 5.93317 4.87338 5.96638 4.87553 5.99949C4.87768 6.03261 4.88634 6.06497 4.901 6.09474C4.91566 6.12451 4.93604 6.15109 4.96097 6.17299C4.98591 6.19488 5.01491 6.21165 5.04633 6.22233C5.07774 6.23301 5.11095 6.2374 5.14407 6.23525C5.14407 6.23525 5.9005 6.13691 5.98371 6.12935C6.02633 6.12519 6.06925 6.13345 6.10728 6.15313C6.14531 6.17282 6.17683 6.20309 6.19804 6.24029C6.24372 6.38153 6.23746 6.53443 6.18038 6.67146C6.11483 6.92361 5.07851 9.84345 5.04573 10.0124C5.01057 10.1538 5.02033 10.3026 5.07366 10.4381C5.12698 10.5737 5.22121 10.6893 5.34326 10.7688C5.57234 10.9215 5.84509 10.995 6.11987 10.9781C6.38704 10.9748 6.65125 10.9218 6.899 10.8218C7.52684 10.5696 8.18242 9.89892 8.52786 9.37194C8.55761 9.3184 8.56684 9.25586 8.55385 9.196C8.54086 9.13614 8.50652 9.08306 8.45726 9.04667Z"
                              fill="white" />
                          </svg>
                        </span>
                        <mat-form-field floatLabel='never'>
                          <input type="text" class="placeholder-input" matInput placeholder="Enter Reply"
                            formControlName="reply">
                        </mat-form-field>
                      </div>
                    </div>
                    <div fxLayout="row">
                      <div fxLayout="column" fxLayoutGap="15px" style="margin-left: 4%;">
                        <label class="mat-input-custom-label responsive-button-text">Select icon</label>
                        <div fxLayout="row" fxLayoutAlign="center center" *ngIf="!iconSelected[i]">
                          <button type="button" class="verify-btn responsive-select-icon-btn"
                            (click)="openIconPopup(i)">Select from
                            Library</button>
                          <!-- <div>{{ element.value.icon }}</div> -->
                        </div>

                        <div fxLayout="row" *ngIf="configueMiniAppsFormGroup.value.buttons.length != 0">
                          <div fxLayout="row"
                            *ngIf="iconSelected[i] && configueMiniAppsFormGroup.get('buttons')['controls'][i].value.icon == 'edit-registration'">
                            <div fxLayout="column" class="icon-library-img responsive-icon-library-img"
                              fxLayoutAlign="center center">
                              <div class="tempalte-img"><svg width="53" height="53" viewBox="0 0 53 53" fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <circle cx="26.051" cy="26.051" r="26.051" fill="#E1E9FE" />
                                </svg>
                              </div>
                              <div class="template-icon-img"><img src="assets/chg-md-img.svg" /></div>
                            </div>

                          </div>
                          <div fxLayout="row" fxLayoutAlign="center center"
                            *ngIf="iconSelected[i] && configueMiniAppsFormGroup.get('buttons')['controls'][i].value.icon == 'registration'">
                            <div fxLayout="column" class="icon-library-img responsive-icon-library-img"
                              fxLayoutAlign="center center">

                              <div class="tempalte-img"><svg width="53" height="53" viewBox="0 0 53 53" fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <circle cx="26.051" cy="26.051" r="26.051" fill="#E1E9FE" />
                                </svg>
                              </div>
                              <div class="template-icon-img"><img src="assets/profile-img.svg" /></div>

                            </div>

                          </div>
                          <div fxLayout="row" fxLayoutAlign="center center"
                            *ngIf="iconSelected[i] && configueMiniAppsFormGroup.get('buttons')['controls'][i].value.icon == 'home'">
                            <div fxLayout="column" class="icon-library-img responsive-icon-library-img"
                              fxLayoutAlign="center center">

                              <div class="tempalte-img"><svg width="53" height="53" viewBox="0 0 53 53" fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <circle cx="26.051" cy="26.051" r="26.051" fill="#E1E9FE" />
                                </svg>
                              </div>
                              <div class="template-icon-img"><img src="assets/home.svg" /></div>

                            </div>

                          </div>
                          <div fxLayout="row" fxLayoutAlign="center center"
                            *ngIf="iconSelected[i] && configueMiniAppsFormGroup.get('buttons')['controls'][i].value.icon == 'edit-age'">
                            <div fxLayout="column" class="icon-library-img responsive-icon-library-img"
                              fxLayoutAlign="center center">

                              <div class="tempalte-img"><svg width="53" height="53" viewBox="0 0 53 53" fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <circle cx="26.051" cy="26.051" r="26.051" fill="#E1E9FE" />
                                </svg>
                              </div>
                              <div class="template-icon-img"><img src="assets/edit-age.svg" /></div>

                            </div>

                          </div>
                          <div fxLayout="column" *ngIf="iconSelected[i]">
                            <div fxLayout="row">

                              <button type="button" class="change-btn" fxLayoutAlign="center center"
                                (click)="openIconPopup(i)">
                                <mat-icon style="margin-right: 10px;">
                                  cached
                                </mat-icon> Change Icon
                              </button>
                            </div>
                            <button type="button" class="change-btn" fxLayoutAlign="center center"
                              (click)="deleteIcon(i)">
                              <mat-icon style="margin-right: 10px;" class="material-symbols-outlined">
                                delete
                              </mat-icon> Delete Icon
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="20px" class="responsive-flex-direction-column-reverse">
                <button type="button" class="verify-btn responsive-width-95"
                  [disabled]="configueMiniAppsFormGroup.invalid" fxFlex="33" fxLayoutAlign="center center"
                  style="padding:10px 0;" (click)="saveMiniAppsDetails('configureMiniApps','saveandexit')">Save & Exit
                  <mat-icon>
                    chevron_right
                  </mat-icon></button>
                <button type="button" [disabled]="configueMiniAppsFormGroup.invalid"
                  class="verify-btn responsive-width-95" fxFlex="33" fxLayoutAlign="center center"
                  style="padding:10px 0;background: #386AF6; color:#fff"
                  (click)="saveMiniAppsDetails('configureMiniApps');">Continue to Review
                  <mat-icon>
                    chevron_right
                  </mat-icon>
                </button>
              </div>
            </div>
          </form>
        </mat-step>
      </mat-stepper>
    </mat-card>
    <div class="hidden-sm" fxLayout="column" fxLayoutAlign="start center" *ngIf="horizantalstepper.selectedIndex == 0" hidden>
      <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" style="margin-top:12%">
        <label class="preview-label">Preview</label>
        <img src="assets/mobile-preview/1.svg" width="250vw" height="450vh" />
      </div>
    </div>
    <div class="hidden-sm" fxLayout="column" fxLayoutAlign="start center" *ngIf="horizantalstepper.selectedIndex == 1" hidden>
      <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" style="margin-top:15% ">
        <label class="preview-label">Preview</label>
        <img src="assets/mobile-preview/mini-app-2.svg" width="250vw" height="500vh" />
      </div>
    </div>
    <div class="hidden-sm" fxLayout="column" fxLayoutAlign="start center" *ngIf="horizantalstepper.selectedIndex == 2" hidden>
      <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" style="margin-top:12%;margin-left: 17%;">
        <label class="preview-label">Preview</label>
        <img src="assets/mobile-preview/mini-app-2.svg" width="250vw" height="500vh" />
      </div>
    </div>
    <div class="hidden-sm" fxLayout="column" hidden>
      <div fxLayout="column" fxLayoutAlign="start center"
        *ngIf="horizantalstepper.selectedIndex == 3 && showFirstImage ">
        <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" style="margin-top:15%; margin-left:17%">
          <label class="preview-label">Preview</label>
          <img src="assets/mobile-preview/mini-app-2.svg" width="250vw" height="500vh" />
        </div>
      </div>
      <div fxLayout="column" fxLayoutAlign="start center"
        *ngIf="horizantalstepper.selectedIndex == 3 && !showFirstImage">
        <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" style="margin-top:15%; margin-left:17%">
          <label class="preview-label">Preview</label>
          <img src="assets/mobile-preview/mini-app-2.svg" width="250vw" height="500vh" />
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap=10px style="margin-bottom: 26px;"
        *ngIf="horizantalstepper.selectedIndex == 3">
        <button type="button" (click)="showFirstImage=true;onClick(1)" fxLayoutAlign="center center"
          [ngClass]="{'active': tab==='tab1'}" class="preview-btn" mat-mini-fab>
          <mat-icon>
            <span class="material-symbols-outlined">
              chevron_left
            </span>
          </mat-icon>
        </button>
        <button type="button" (click)="showFirstImage=false;onClick(2)" [ngClass]="{'active': tab==='tab2'}"
          fxLayoutAlign="center center" class="preview-btn" mat-mini-fab>
          <mat-icon>
            <span class="material-symbols-outlined">
              chevron_right
            </span>
          </mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
<ng-template id="checkpreview" #checkpreview>
  <button class="close" style="padding: 10px;" mat-button (click)="_matDialog.closeAll()">
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.93909 3.99943L7.80299 1.14179C7.92841 1.01635 7.99886 0.846231 7.99886 0.668843C7.99886 0.491455 7.92841 0.321332 7.80299 0.1959C7.67758 0.0704672 7.50748 0 7.33011 0C7.15275 0 6.98265 0.0704672 6.85724 0.1959L4 3.06021L1.14276 0.1959C1.01735 0.0704672 0.847248 -1.32164e-09 0.669885 0C0.492522 1.32165e-09 0.322423 0.0704672 0.197008 0.1959C0.0715939 0.321332 0.00113664 0.491455 0.00113663 0.668843C0.00113663 0.846231 0.0715939 1.01635 0.197008 1.14179L3.06091 3.99943L0.197008 6.85708C0.134583 6.919 0.085035 6.99267 0.0512219 7.07385C0.0174088 7.15502 0 7.24208 0 7.33002C0 7.41795 0.0174088 7.50502 0.0512219 7.58619C0.085035 7.66737 0.134583 7.74104 0.197008 7.80296C0.258924 7.8654 0.332587 7.91495 0.413748 7.94877C0.494909 7.98259 0.581962 8 0.669885 8C0.757808 8 0.844861 7.98259 0.926022 7.94877C1.00718 7.91495 1.08085 7.8654 1.14276 7.80296L4 4.93866L6.85724 7.80296C6.91915 7.8654 6.99282 7.91495 7.07398 7.94877C7.15514 7.98259 7.24219 8 7.33011 8C7.41804 8 7.50509 7.98259 7.58625 7.94877C7.66741 7.91495 7.74108 7.8654 7.80299 7.80296C7.86542 7.74104 7.91497 7.66737 7.94878 7.58619C7.98259 7.50502 8 7.41795 8 7.33002C8 7.24208 7.98259 7.15502 7.94878 7.07385C7.91497 6.99267 7.86542 6.919 7.80299 6.85708L4.93909 3.99943Z"
        fill="#0E0E0E" />
    </svg>
  </button>
  <div style="padding: 1.5rem;">
    <div fxLayout="column" fxLayoutAlign="start center" *ngIf="horizantalstepper.selectedIndex == 0">
      <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" style="margin-top:12%">
        <label class="preview-label">Example Screen</label>
        <img src="assets/mobile-preview/1.svg" width="250vw" height="450vh" />
      </div>
    </div>
    <div fxLayout="column" fxLayoutAlign="start center" *ngIf="horizantalstepper.selectedIndex == 1">
      <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" style="margin-top:15% ">
        <label class="preview-label">Example Screen</label>
        <img src="assets/mobile-preview/mini-app-2.svg" width="250vw" height="500vh" />
      </div>
    </div>
    <div fxLayout="column" fxLayoutAlign="start center" *ngIf="horizantalstepper.selectedIndex == 2">
      <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" style="margin-top:12%">
        <label class="preview-label">Example Screen</label>
        <img src="assets/mobile-preview/mini-app-2.svg" width="250vw" height="500vh" />
      </div>
    </div>
    <div fxLayout="column">
      <div fxLayout="column" fxLayoutAlign="start center"
        *ngIf="horizantalstepper.selectedIndex == 3 && showFirstImage ">
        <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" style="margin-top:15%">
          <label class="preview-label">Example Screen</label>
          <img src="assets/mobile-preview/mini-app-2.svg" width="250vw" height="500vh" />
        </div>
      </div>
      <div fxLayout="column" fxLayoutAlign="start center"
        *ngIf="horizantalstepper.selectedIndex == 3 && !showFirstImage">
        <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" style="margin-top:15%">
          <label class="preview-label">Example Screen</label>
          <img src="assets/mobile-preview/mini-app-2.svg" width="250vw" height="500vh" />
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap=10px style="margin-bottom: 26px;"
        *ngIf="horizantalstepper.selectedIndex == 3">
        <button type="button" (click)="showFirstImage=true;onClick(1)" fxLayoutAlign="center center"
          [ngClass]="{'active': tab==='tab1'}" class="preview-btn" mat-mini-fab>
          <mat-icon>
            <span class="material-symbols-outlined">
              chevron_left
            </span>
          </mat-icon>
        </button>
        <button type="button" (click)="showFirstImage=false;onClick(2)" [ngClass]="{'active': tab ==='tab2'}"
          fxLayoutAlign="center center" class="preview-btn" mat-mini-fab>
          <mat-icon>
            <span class="material-symbols-outlined">
              chevron_right
            </span>
          </mat-icon>
        </button>
      </div>
    </div>
  </div>
</ng-template>